/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetSocialQqUserinfoRequest = { qq: string };

export const GetSocialQqUserinfoRequest$zodSchema: z.ZodType<
  GetSocialQqUserinfoRequest
> = z.object({
  qq: z.string().describe("需要查询的QQ号"),
});

export type GetSocialQqUserinfoNotFoundDetails = {};

export const GetSocialQqUserinfoNotFoundDetails$zodSchema: z.ZodType<
  GetSocialQqUserinfoNotFoundDetails
> = z.object({});

/**
 * 获取QQ用户信息失败或用户不存在
 */
export type GetSocialQqUserinfoNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetSocialQqUserinfoNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetSocialQqUserinfoNotFoundResponseBody$zodSchema: z.ZodType<
  GetSocialQqUserinfoNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetSocialQqUserinfoNotFoundDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("获取QQ用户信息失败或用户不存在");

export type GetSocialQqUserinfoBadRequestDetails = {};

export const GetSocialQqUserinfoBadRequestDetails$zodSchema: z.ZodType<
  GetSocialQqUserinfoBadRequestDetails
> = z.object({});

/**
 * 缺少或无效的qq参数
 */
export type GetSocialQqUserinfoBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetSocialQqUserinfoBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetSocialQqUserinfoBadRequestResponseBody$zodSchema: z.ZodType<
  GetSocialQqUserinfoBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetSocialQqUserinfoBadRequestDetails$zodSchema)
    .optional(),
  message: z.string().optional(),
}).describe("缺少或无效的qq参数");

/**
 * 成功响应，返回QQ用户的详细信息
 */
export type GetSocialQqUserinfoResponseBody = {
  qq?: string | undefined;
  nickname?: string | undefined;
  long_nick?: string | undefined;
  avatar_url?: string | undefined;
  age?: number | undefined;
  sex?: string | undefined;
  qid?: string | undefined;
  qq_level?: number | undefined;
  location?: string | undefined;
  email?: string | undefined;
  is_vip?: boolean | undefined;
  vip_level?: number | undefined;
  reg_time?: string | undefined;
  last_updated?: string | undefined;
};

export const GetSocialQqUserinfoResponseBody$zodSchema: z.ZodType<
  GetSocialQqUserinfoResponseBody
> = z.object({
  age: z.int().optional(),
  avatar_url: z.string().optional(),
  email: z.string().optional(),
  is_vip: z.boolean().optional(),
  last_updated: z.string().optional(),
  location: z.string().optional(),
  long_nick: z.string().optional(),
  nickname: z.string().optional(),
  qid: z.string().optional(),
  qq: z.string().optional(),
  qq_level: z.int().optional(),
  reg_time: z.string().optional(),
  sex: z.string().optional(),
  vip_level: z.int().optional(),
}).describe("成功响应，返回QQ用户的详细信息");

export type GetSocialQqUserinfoResponse =
  | GetSocialQqUserinfoResponseBody
  | GetSocialQqUserinfoBadRequestResponseBody
  | GetSocialQqUserinfoNotFoundResponseBody;

export const GetSocialQqUserinfoResponse$zodSchema: z.ZodType<
  GetSocialQqUserinfoResponse
> = z.union([
  z.lazy(() => GetSocialQqUserinfoResponseBody$zodSchema),
  z.lazy(() => GetSocialQqUserinfoBadRequestResponseBody$zodSchema),
  z.lazy(() => GetSocialQqUserinfoNotFoundResponseBody$zodSchema),
]);
